"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  common: {
    ok: 'OK',
    error: 'Error',
    errorTitle: 'Error',
    success: 'Éxito',
    unexpectedError: 'Lo siento, ocurrió un error inesperado. Por favor, inténtalo de nuevo más tarde.'
  },
  imageDocumentPreview: {
    error: 'Vista previa de imagen no disponible'
  },
  pdfDocumentPreview: {
    pdfError: 'Vista previa de PDF no disponible',
    empty: 'No hay archivo'
  },
  date: {
    rangeFilterName: 'Rango de fechas',
    any: 'Cualquier momento',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    rangeSeparator: 'a',
    placeholder: 'Fecha',
    presets: {
      today: 'Hoy',
      thisWeek: 'Esta semana',
      lastWeek: 'La semana pasada',
      thisMonth: 'Este mes',
      lastMonth: 'El mes pasado'
    }
  },
  tableFooter: {
    showing: 'Mostrando {{pageStart}} a {{pageEnd}} de {{totalItemsCount}} {{dataName}}',
    mobileShowing: 'Mostrando {{pageStart}} - {{pageEnd}} {{dataName}}'
  },
  emailBox: {
    emailInvoice: 'Envíanos tu factura por correo electrónico (los proveedores también pueden usar esto):',
    emailSupliersCompleteData: 'Envía a los proveedores un enlace para completar sus datos:',
    emailSupliersSendQuote: 'Envía a los proveedores un enlace para enviar una cotización:',
    copied: '¡Copiado!'
  },
  amountCell: {
    converted: 'Convertido:'
  },
  addFiltersToggle: {
    add: 'Agregar filtros'
  },
  filtersLayout: {
    search: 'Buscar...'
  },
  settingsLayout: {
    title: 'Configuraciones'
  },
  reportsLayout: {
    title: 'Informes'
  },
  additionalFiltersLayout: {
    filterBy: 'Filtrar por',
    apply: 'Aplicar filtros',
    clear: 'Borrar filtros'
  },
  fileUploader: {
    buttonText: 'Subir archivo',
    fileSizeError: 'El tamaño del archivo no puede exceder más de {{maxSizeMb}}MB.',
    defaultEmptyText: 'Ningún archivo seleccionado'
  },
  fileDropZone: {
    remove: 'Eliminar',
    browse: 'o buscar aquí'
  },
  statusLabel: {
    approved: 'APROBADO',
    pending: 'PENDIENTE',
    awaitingApproval: 'ESPERANDO APROBACIÓN',
    notSubmitted: 'NO ENVIADO',
    draft: 'BORRADOR',
    cancelled: 'CANCELADO',
    declined: 'RECHAZADO',
    completed: 'COMPLETADO'
  },
  errors: {
    pageNotFound: 'Esta página no se pudo encontrar.',
    unexpectedError: 'Algo salió mal, por favor contacta al soporte.',
    returnToLogin: 'Volver al inicio de sesión',
    error: 'Error',
    uiSettingsIssue: 'Hay un problema en las configuraciones de la interfaz.'
  },
  inputPassword: {
    hide: 'Ocultar',
    show: 'Mostrar'
  },
  inputAmount: {
    popularGroup: 'Popular',
    otherGroup: 'Otro'
  },
  phonePicker: {
    searchPlaceholder: 'Escribe para buscar...',
    noCountriesText: 'No se encontraron países'
  },
  multiPhonePicker: {
    addNewLabel: 'Agregar número de teléfono adicional'
  },
  formField: {
    optional: '(Opcional)'
  },
  dateCell: {
    futurePayment: 'Pago futuro'
  },
  multiSearchSelect: {
    all: 'Todo',
    selectAll: 'Seleccionar todo',
    deselectAll: 'Deseleccionar todo',
    noOptions: 'No se encontraron opciones'
  },
  currencies: {
    AED: 'Dírham de los Emiratos Árabes Unidos',
    AFN: 'Afgani afgano',
    ALL: 'Lek albanés',
    AMD: 'Dram armenio',
    ANG: 'Florín de las Antillas Neerlandesas',
    AOA: 'Kwanza angoleño',
    ARS: 'Peso argentino',
    AUD: 'Dólar australiano',
    AWG: 'Florín arubeño',
    AZN: 'Manat azerbaiyano',
    BAM: 'Marco convertible de Bosnia y Herzegovina',
    BBD: 'Dólar de Barbados',
    BDT: 'Taka bangladesí',
    BGN: 'Lev búlgaro',
    BHD: 'Dinar bahreiní',
    BIF: 'Franco burundés',
    BMD: 'Dólar bermudeño',
    BND: 'Dólar de Brunéi',
    BOB: 'Boliviano',
    BRL: 'Real brasileño',
    BSD: 'Dólar bahameño',
    BTN: 'Ngultrum butanés',
    BWP: 'Pula botsuano',
    BYN: 'Rublo bielorruso',
    BZD: 'Dólar beliceño',
    CAD: 'Dólar canadiense',
    CDF: 'Franco congoleño',
    CHF: 'Franco suizo',
    CLP: 'Peso chileno',
    CNY: 'Yuan chino',
    COP: 'Peso colombiano',
    CRC: 'Colón costarricense',
    CUC: 'Peso convertible cubano',
    CVE: 'Escudo caboverdiano',
    CZK: 'Corona checa',
    DJF: 'Franco yibutiano',
    DKK: 'Corona danesa',
    DOP: 'Peso dominicano',
    DZD: 'Dinar argelino',
    EGP: 'Libra egipcia',
    ERN: 'Nakfa eritreo',
    ETB: 'Birr etíope',
    EUR: 'Euro',
    FJD: 'Dólar fiyiano',
    FKP: 'Libra de las Islas Malvinas',
    GBP: 'Libra esterlina',
    GEL: 'Lari georgiano',
    GHS: 'Cedi ghanés',
    GIP: 'Libra de Gibraltar',
    GMD: 'Dalasi gambiano',
    GNF: 'Franco guineano',
    GTQ: 'Quetzal guatemalteco',
    GYD: 'Dólar guyanés',
    HKD: 'Dólar de Hong Kong',
    HNL: 'Lempira hondureño',
    HRK: 'Kuna croata',
    HTG: 'Gurda haitiana',
    HUF: 'Florín húngaro',
    IDR: 'Rupia indonesia',
    ILS: 'Nuevo shékel israelí',
    INR: 'Rupia india',
    IQD: 'Dinar iraquí',
    IRR: 'Rial iraní',
    ISK: 'Corona islandesa',
    JMD: 'Dólar jamaicano',
    JOD: 'Dinar jordano',
    JPY: 'Yen japonés',
    KES: 'Chelín keniano',
    KGS: 'Som kirguís',
    KHR: 'Riel camboyano',
    KMF: 'Franco comorense',
    KPW: 'Won norcoreano',
    KRW: 'Won surcoreano',
    KWD: 'Dinar kuwaití',
    KYD: 'Dólar de las Islas Caimán',
    KZT: 'Tenge kazajo',
    LAK: 'Kip laosiano',
    LBP: 'Libra libanesa',
    LKR: 'Rupia de Sri Lanka',
    LRD: 'Dólar liberiano',
    LSL: 'Loti lesothense',
    LYD: 'Dinar libio',
    MAD: 'Dírham marroquí',
    MDL: 'Leu moldavo',
    MGA: 'Ariary malgache',
    MKD: 'Dinar macedonio',
    MMK: 'Kyat birmano',
    MNT: 'Tugrik mongol',
    MOP: 'Pataca macaense',
    MRO: 'Ouguiya mauritano',
    MUR: 'Rupia mauriciana',
    MVR: 'Rufiyaa maldivo',
    MWK: 'Kwacha malauí',
    MXN: 'Peso mexicano',
    MYR: 'Ringgit malayo',
    MZN: 'Metical mozambiqueño',
    NAD: 'Dólar namibio',
    NGN: 'Naira nigeriano',
    NIO: 'Córdoba nicaragüense',
    NOK: 'Corona noruega',
    NPR: 'Rupia nepalí',
    NZD: 'Dólar neozelandés',
    OMR: 'Rial omaní',
    PAB: 'Balboa panameño',
    PEN: 'Sol peruano',
    PGK: 'Kina papuana',
    PHP: 'Peso filipino',
    PKR: 'Rupia pakistaní',
    PLN: 'Zloty polaco',
    PYG: 'Guaraní paraguayo',
    QAR: 'Riyal catarí',
    RON: 'Leu rumano',
    RSD: 'Dinar serbio',
    RUB: 'Rublo ruso',
    RWF: 'Franco ruandés',
    SAR: 'Riyal saudí',
    SBD: 'Dólar de las Islas Salomón',
    SCR: 'Rupia seychellense',
    SDG: 'Libra sudanesa',
    SEK: 'Corona sueca',
    SGD: 'Dólar singapurense',
    SHP: 'Libra de Santa Elena',
    SLL: 'Leone de Sierra Leona',
    SOS: 'Chelín somalí',
    SRD: 'Dólar surinamés',
    SSP: 'Libra sursudanesa',
    STD: 'Dobra de Santo Tomé y Príncipe',
    SVC: 'Colón salvadoreño',
    SYP: 'Libra siria',
    SZL: 'Lilangeni suazi',
    THB: 'Baht tailandés',
    TJS: 'Somoni tayiko',
    TMT: 'Manat turcomano',
    TND: 'Dinar tunecino',
    TOP: "Pa'anga tongano",
    TRY: 'Lira turca',
    TTD: 'Dólar de Trinidad y Tobago',
    TWD: 'Nuevo dólar taiwanés',
    TZS: 'Chelín tanzano',
    UAH: 'Grivna ucraniana',
    UGX: 'Chelín ugandés',
    USD: 'Dólar estadounidense',
    UYU: 'Peso uruguayo',
    UZS: 'Som uzbeko',
    VEF: 'Bolívar venezolano',
    VND: 'Dong vietnamita',
    VUV: 'Vatu vanuatuense',
    WST: 'Tala samoano',
    YER: 'Rial yemení',
    ZAR: 'Rand sudafricano',
    ZMW: 'Kwacha zambiano',
    ZWL: 'Dólar zimbabuense'
  },
  countries: {
    AF: 'Afganistán',
    AX: 'Islas Åland',
    AL: 'Albania',
    DZ: 'Argelia',
    AS: 'Samoa Americana',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguila',
    AQ: 'Antártida',
    AG: 'Antigua y Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaiyán',
    BS: 'Bahamas',
    BH: 'Baréin',
    BD: 'Bangladés',
    BB: 'Barbados',
    BY: 'Bielorrusia',
    BE: 'Bélgica',
    BZ: 'Belice',
    BJ: 'Benín',
    BM: 'Bermudas',
    BT: 'Bután',
    BO: 'Bolivia, Estado Plurinacional de',
    BQ: 'Bonaire, San Eustaquio y Saba',
    BA: 'Bosnia y Herzegovina',
    BW: 'Botsuana',
    BV: 'Isla Bouvet',
    BR: 'Brasil',
    IO: 'Territorio Británico del Océano Índico',
    BN: 'Brunéi Darussalam',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Camboya',
    CM: 'Camerún',
    CA: 'Canadá',
    CV: 'Cabo Verde',
    KY: 'Islas Caimán',
    CF: 'República Centroafricana',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Isla de Navidad',
    CC: 'Islas Cocos (Keeling)',
    CO: 'Colombia',
    KM: 'Comoras',
    CG: 'Congo',
    CD: 'Congo, República Democrática del',
    CK: 'Islas Cook',
    CR: 'Costa Rica',
    CI: 'Costa de Marfil',
    HR: 'Croacia',
    CU: 'Cuba',
    CW: 'Curazao',
    CY: 'Chipre',
    CZ: 'República Checa',
    DK: 'Dinamarca',
    DJ: 'Yibuti',
    DM: 'Dominica',
    DO: 'República Dominicana',
    EC: 'Ecuador',
    EG: 'Egipto',
    SV: 'El Salvador',
    GQ: 'Guinea Ecuatorial',
    ER: 'Eritrea',
    EE: 'Estonia',
    ET: 'Etiopía',
    FK: 'Islas Malvinas',
    FO: 'Islas Feroe',
    FJ: 'Fiyi',
    FI: 'Finlandia',
    FR: 'Francia',
    GF: 'Guayana Francesa',
    PF: 'Polinesia Francesa',
    TF: 'Territorios Australes Franceses',
    GA: 'Gabón',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Alemania',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Grecia',
    GL: 'Groenlandia',
    GD: 'Granada',
    GP: 'Guadalupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'Guinea-Bisáu',
    GY: 'Guyana',
    HT: 'Haití',
    HM: 'Islas Heard y McDonald',
    VA: 'Santa Sede (Estado de la Ciudad del Vaticano)',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungría',
    IS: 'Islandia',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Irán, República Islámica de',
    IQ: 'Irak',
    IE: 'Irlanda',
    IM: 'Isla de Man',
    IL: 'Israel',
    IT: 'Italia',
    JM: 'Jamaica',
    JP: 'Japón',
    JE: 'Jersey',
    JO: 'Jordania',
    KZ: 'Kazajistán',
    KE: 'Kenia',
    KI: 'Kiribati',
    KP: 'Corea, República Popular Democrática de',
    KR: 'Corea, República de',
    KW: 'Kuwait',
    KG: 'Kirguistán',
    LA: 'República Democrática Popular Lao',
    LV: 'Letonia',
    LB: 'Líbano',
    LS: 'Lesoto',
    LR: 'Liberia',
    LY: 'Libia',
    LI: 'Liechtenstein',
    LT: 'Lituania',
    LU: 'Luxemburgo',
    MO: 'Macao',
    MK: 'Macedonia, Antigua República Yugoslava de',
    MG: 'Madagascar',
    MW: 'Malaui',
    MY: 'Malasia',
    MV: 'Maldivas',
    ML: 'Malí',
    MT: 'Malta',
    MH: 'Islas Marshall',
    MQ: 'Martinica',
    MR: 'Mauritania',
    MU: 'Mauricio',
    YT: 'Mayotte',
    MX: 'México',
    FM: 'Micronesia, Estados Federados de',
    MD: 'Moldavia, República de',
    MC: 'Mónaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Marruecos',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Países Bajos',
    NC: 'Nueva Caledonia',
    NZ: 'Nueva Zelanda',
    NI: 'Nicaragua',
    NE: 'Níger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Isla Norfolk',
    MP: 'Islas Marianas del Norte',
    NO: 'Noruega',
    OM: 'Omán',
    PK: 'Pakistán',
    PW: 'Palaos',
    PS: 'Palestina, Estado de',
    PA: 'Panamá',
    PG: 'Papúa Nueva Guinea',
    PY: 'Paraguay',
    PE: 'Perú',
    PH: 'Filipinas',
    PN: 'Pitcairn',
    PL: 'Polonia',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Catar',
    RE: 'Reunión',
    RO: 'Rumania',
    RU: 'Federación de Rusia',
    RW: 'Ruanda',
    BL: 'San Bartolomé',
    SH: 'Santa Elena, Ascensión y Tristán de Acuña',
    KN: 'San Cristóbal y Nieves',
    LC: 'Santa Lucía',
    MF: 'San Martín (parte francesa)',
    PM: 'San Pedro y Miquelón',
    VC: 'San Vicente y las Granadinas',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Santo Tomé y Príncipe',
    SA: 'Arabia Saudita',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leona',
    SG: 'Singapur',
    SX: 'Sint Maarten (parte holandesa)',
    SK: 'Eslovaquia',
    SI: 'Eslovenia',
    SB: 'Islas Salomón',
    SO: 'Somalia',
    ZA: 'Sudáfrica',
    GS: 'Georgia del Sur y las Islas Sandwich del Sur',
    SS: 'Sudán del Sur',
    ES: 'España',
    LK: 'Sri Lanka',
    SD: 'Sudán',
    SR: 'Surinam',
    SJ: 'Svalbard y Jan Mayen',
    SZ: 'Suazilandia',
    SE: 'Suecia',
    CH: 'Suiza',
    SY: 'República Árabe Siria',
    TW: 'Taiwán, Provincia de China',
    TJ: 'Tayikistán',
    TZ: 'Tanzania, República Unida de',
    TH: 'Tailandia',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad y Tobago',
    TN: 'Túnez',
    TR: 'Turquía',
    TM: 'Turkmenistán',
    TC: 'Islas Turcas y Caicos',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ucrania',
    AE: 'Emiratos Árabes Unidos',
    GB: 'Reino Unido',
    US: 'Estados Unidos',
    UM: 'Islas Ultramarinas Menores de los Estados Unidos',
    UY: 'Uruguay',
    UZ: 'Uzbekistán',
    VU: 'Vanuatu',
    VE: 'Venezuela, República Bolivariana de',
    VN: 'Vietnam',
    VG: 'Islas Vírgenes Británicas',
    VI: 'Islas Vírgenes de los Estados Unidos',
    WF: 'Wallis y Futuna',
    EH: 'Sahara Occidental',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabue'
  },
  states: {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming'
  },
  inlineEdit: {
    save: 'Guardar',
    cancel: 'Cancelar'
  },
  formPageLayout: {
    discard: 'Descartar y volver atrás'
  },
  multiSelect: {
    clearAll: 'Borrar todo'
  },
  filterMultiSelect: {
    andMore: 'y {{count}} más'
  },
  inlineEditTrigger: {
    edit: 'Editar'
  },
  searchSelect: {
    noOptions: 'Sin opciones'
  },
  cardDetails: {
    title: 'Detalles de la tarjeta: x{{lastDigits}}',
    detailsHeader: 'Detalles de la tarjeta',
    data: {
      number: 'Número de tarjeta',
      holder: 'Titular de la tarjeta',
      expiryDate: 'Fecha de vencimiento'
    },
    billingInformation: 'Información de facturación',
    billingAddress: 'Dirección de facturación',
    vatNumber: 'Número de IVA',
    closeCardDetails: 'Cerrar detalles de la tarjeta',
    copyNumber: 'Copiar número',
    copied: 'Copiado'
  },
  addressPicker: {
    enterAddressManually: '¿No puedes ver tu dirección? Ingresa manualmente'
  },
  panelDocumentInfo: {
    download: 'Descargar',
    noDocument: 'Documento no cargado'
  },
  accountBalances: {
    availableBalance: 'Saldo disponible'
  },
  payAccountlayout: {
    loading: 'Cargando...',
    select: 'Seleccionar'
  }
};
exports.default = _default;